import toast from '../components/toast';

const renderSuccessToast = message => toast.success(message);

export default renderSuccessToast;
